"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = function Twitter(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M15.719 5.95c.006.132.009.265.009.396 0 4.055-3.227 8.728-9.129 8.728a9.382 9.382 0 0 1-4.919-1.379c.252.029.507.043.765.043 1.505 0 2.887-.49 3.985-1.312-1.404-.025-2.59-.91-2.997-2.13a3.426 3.426 0 0 0 1.449-.052C3.414 9.96 2.308 8.722 2.308 7.235v-.038c.433.23.928.368 1.454.384-.861-.55-1.428-1.488-1.428-2.553 0-.562.158-1.09.435-1.542C4.35 5.342 6.716 6.563 9.383 6.69a2.967 2.967 0 0 1-.083-.7c0-1.693 1.436-3.065 3.208-3.065.923 0 1.757.371 2.343.967a6.645 6.645 0 0 0 2.037-.744 3.107 3.107 0 0 1-1.41 1.697 6.65 6.65 0 0 0 1.842-.483 6.33 6.33 0 0 1-1.601 1.587z" })
  );
};

exports.default = Twitter;
Twitter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Twitter"
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/Twitter.js
// module id = 631
// module chunks = 0